import { useState, useMemo } from 'react'

import {
	EuiDatePicker,
	EuiDatePickerRange,
} from '@equipmentshare/ds2'

import { findMaxTime } from '../../../../helpers/utils'
import moment, { Moment } from 'moment'

export type DateRangeFilterProps = {
	startDate?: Moment,
	endDate?: Moment,
	setStartDate: ( sd?: Moment ) => void,
	setEndDate: ( ed?: Moment ) => void,
}

export function DateRangeFilter( { startDate, setStartDate, endDate, setEndDate }: DateRangeFilterProps ) {
	const onChangeStartDate = ( date?: Moment | null ) => {
		if ( date === null ) {
			setStartDate()
		} else {
			setStartDate( date )
		}
	}

	const onChangeEndDate = ( date?: Moment | null ) => {
		if ( date === null ) {
			setEndDate()
		} else {
			setEndDate( date )
		}
	}

	return (
		<EuiDatePickerRange
			startDateControl={
				<EuiDatePicker
					selected={startDate}
					onChange={onChangeStartDate}
					aria-label="Start date"
					maxDate={moment()}
					maxTime={startDate !== undefined ? findMaxTime( startDate ) : moment()}
					minTime={moment().utc().startOf( 'day' )}
					showTimeSelect
				/>
			}
			endDateControl={
				<EuiDatePicker
					selected={endDate}
					onChange={onChangeEndDate}
					aria-label="End date"
					maxDate={moment()}
					maxTime={endDate !== undefined ? findMaxTime( endDate ) : moment()}
					minTime={moment().utc().startOf( 'day' )}
					showTimeSelect
				/>
			}
		/>
	)
}

export function buildDateRangeFilterVariables( startDate?: Moment, endDate?: Moment ) {
	const variables: {
		createdDateStart?: string,
		createdDateEnd?: string,
	} = {}

	if ( startDate ) {
		variables.createdDateStart = startDate.format()
	}
	if ( endDate ) {
		variables.createdDateEnd = endDate.format()
	}

	return variables
}


export type UseDateRangeFilterProps = {
  onStartDateChange?: ( date?: Moment ) => void,
  onEndDateChange?: ( date?: Moment ) => void,
}

export default function useDateRangeFilter( props: UseDateRangeFilterProps = {} ) {
	const [ startDate, setStartDate ] = useState<Moment>()
	const [ endDate, setEndDate ] = useState<Moment>()

	const filterVariables = useMemo( () => buildDateRangeFilterVariables( startDate, endDate ), [ startDate, endDate ] )

	return {
		filterVariables,
		render: () => (
			<DateRangeFilter
				startDate={startDate}
				setStartDate={( d ) => {
					setStartDate( d )
					if ( props.onStartDateChange ) {
						props.onStartDateChange( d )
					}
				}}
				endDate={endDate}
				setEndDate={( d ) => {
					setEndDate( d )
					if ( props.onEndDateChange ) {
						props.onEndDateChange( d )
					}
				}}
			/>
		)
	}
}
